import React from 'react';
import { injectStripe, CardElement } from 'react-stripe-elements';
import Modal from 'components/UI/Modal';
import processPayment from 'controllers/payment/processPayment';
import { alert } from 'util/alert';
import "./CheckoutModal.scss";
import { browserHistory } from 'react-router';

const PLAN_CODENAME = 'regular_usd_monthly';

// This is how you modify the style of CardElement
// You can't do it with plain CSS
const cardElementStyle = {
	base: {
		iconColor: '#D2D2D2',
		fontWeight: 300,
		'::placeholder': {
			fontWeight: 300,
			color: '#D2D2D2',
			fontSize: '12px',
			lineHeight: '13px',
		}
	}
}

const PRICE = '$79';

const locale = {
  id: 'OrderOverview',
  code: 'CN',
  text: {
    'All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.': '所有付款都通过 Stripe 处理。付款连接是安全并且加密的。我们不会收集您的任何信息。',
    'month per school': '每个学校一个月',
    'Privacy Policy': '隐私政策',
    'Note: 5% tax will be applied on every transaction': '提示: 每次付款会额外收取5%的税金'
  }
}

class CheckoutModal extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      email: '',
			class: 'form-control email-input',
			processingPayment: false
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeEmail = this.onChangeEmail.bind(this)
  }

  onChangeEmail(event){
		let validation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		if (validation.test(event.target.value)) {
			this.setState({class: 'form-control email-input'})
		} else {
			this.setState({class: 'form-control email-input email-error'})
		}

    this.state.email = event.target.value
    this.setState({email: this.state.email})
  }

  onSubmit(ev){
		let {
      proceed,
      dismiss: dismissModal,
      cancel,
			onSuccess,
		} = this.props;

    ev.preventDefault();

    if(!this.state.email) {
		  this.setState({class: 'form-control email-input email-error'})
		  ev.preventDefault();
      return;
    }

    // We could pass customer to createToken()
    // let customer = {}
		this.setState({processingPayment: true})
    this.props.stripe.createToken().then((payload) => {
      processPayment({
        source: payload.token.id,
        email: this.state.email,
        plan_codename: PLAN_CODENAME,
        quantity: 1,
      })
        .then((success)=> {
					dismissModal()
          alert.success("", __('Your purchase is successful!', 'checkoutform')).then(() => {
            // instead of closing the whole thing we redirect/refresh the window

						if (typeof(onSuccess) == 'function') {
							onSuccess()
						}
          });
        })
        .catch((err)=> {
          console.log(err);
        });
    }).catch(() => {
      return;
    })
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
    } = this.props;

		let currentLocale = localStorage.getItem('language')

		return (
			<Modal
				className='checkout-modal'

				hasHeader={true}
				hasFooter={true}
				headerTitle={__("Upgrade to Premium", "teacher")}
				headerIcon="fa icon-credit-card"
        fixedWidth={500}
        onCloseModalClick={dismiss}

        footerType="grey"
				footerButtons={[
					{
						title: __("Submit Payment", "checkoutform"),
						className: "btn btn-primary pull-right",
						isDisabled: ()=>{return this.state.processingPayment},
						onClick: this.onSubmit,
					}
				]}
				isShowingModal={show}
				footerCustomContent={
					<div className='price-on-modal'>{PRICE + " / " + __("month per school", locale)}</div>
				}
			>
        <div className='row upgrade-info'>
          <div className='col-md-12' style={{marginBottom: '20px'}}>
            <label>{__('Email Address', 'checkoutform', null, true)}</label>
            <input placeholder='name@mail.com' className={this.state.class} type='email' value={this.state.email} onChange={this.onChangeEmail} />
          </div>
          <div className='col-md-12' style={{marginBottom: '20px'}}>
            <label>{__('Credit or Debit Card', 'checkoutform', null, true)}</label>
            <CardElement className='stripe-cardnumber' style={cardElementStyle} />
          </div>
          <div className='col-md-12 secure-msg'>{__('Note: 5% tax will be applied on every transaction', locale)}</div>
					<span className='col-md-12 secure-msg'>
						{__('All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.', locale)}
						<a target='__blank' href={`/privacy-${currentLocale.toLowerCase()}`}>{__('Privacy Policy', locale)}</a>
					</span>
        </div>
			</Modal>
    );
  }
}

export default injectStripe(CheckoutModal);



// WEBPACK FOOTER //
// ./src/template/Modals/MyStoreCheckout/CheckoutModal.js